export default __webpack_public_path__ + "static/media/aii.7fc99cd6.png";